import { Action } from "redux"
import { IAddin, IConfiguration, IPackageDiff } from "./index"

export const INITIALIZE = "DEPLOYMENT_INITIALIZE"
export const SET_INITIALIZED = "DEPLOYMENT_SET_INITIALIZED"
export const REQUEST_CONFIGURATIONS = "DEPLOYMENT_REQUEST_CONFIGURATIONS"
export const REQUEST_INSTALLED_CONFIGURATIONS =
    "DEPLOYMENT_REQUEST_INSTALLED_CONFIGURATIONS"
export const RECEIVE_CONFIGURATIONS = "DEPLOYMENT_RECEIVE_CONFIGURATIONS"
export const REQUEST_EXAMPLE = "DEPLOYMENT_REQUEST_EXAMPLE"
export const REQUEST_SOURCE = "DEPLOYMENT_REQUEST_SOURCE"
export const RECEIVE_SOURCE = "DEPLOYMENT_RECEIVE_SOURCE"
export const EXPORT_CONFIGURATION = "DEPLOYMENT_EXPORT_CONFIGURATION"
export const REMOVE_CONFIGURATION = "DEPLOYMENT_REMOVE_CONFIGURATION"
export const SAVE_SOURCE = "DEPLOYMENT_SAVE_SOURCE"
export const CLOSE_EDITOR = "DEPLOYMENT_CLOSE_EDITOR"
export const REQUEST_PACKAGE_DIFF = "DEPLOYMENT_REQUEST_PACKAGE_DIFF"
export const RECEIVE_PACKAGE_DIFF = "DEPLOYMENT_RECEIVE_PACKAGE_DIFF"
export const MAKE_SNAPSHOT = "DEPLOYMENT_MAKE_SNAPSHOT"
export const REQUEST_PACKAGE_ADDIN_DIFFS =
    "DEPLOYMENT_REQUEST_PACKAGE_ADDIN_DIFFS"
export const RECEIVE_PACKAGE_ADDIN_DIFFS =
    "DEPLOYMENT_RECEIVE_PACKAGE_ADDIN_DIFFS"

export interface ReceiveConfigurations extends Action {
    configurations: IConfiguration[]
}

export interface ReceivePackageDiff extends Action {
    packageDiff: IPackageDiff
}

export interface ConfigurationId extends Action {
    id: string
}

export interface PackageSource extends Action {
    source: string
}

export interface DeploymentAction extends Action {
    which: string
}

export interface RequestExample extends Action {
    clean: boolean
}

export interface ReceivePackageAddinDiffs extends Action {
    id: string
    addinDiffs: IAddin[]
}

export const initialize = (which: string): DeploymentAction => ({
    type: INITIALIZE,
    which,
})

export const setInitialized = (): Action => ({ type: SET_INITIALIZED })

export const requestConfigurations = (): Action => ({
    type: REQUEST_CONFIGURATIONS,
})

export const requestInstalledConfigurations = (): Action => ({
    type: REQUEST_INSTALLED_CONFIGURATIONS,
})

export const receiveConfigurations = (
    configurations: IConfiguration[],
): ReceiveConfigurations => ({ type: RECEIVE_CONFIGURATIONS, configurations })

export const exportConfiguration = (id: string): ConfigurationId => ({
    type: EXPORT_CONFIGURATION,
    id,
})

export const removeConfiguration = (id: string): ConfigurationId => ({
    type: REMOVE_CONFIGURATION,
    id,
})

export const requestExample = (clean: boolean): RequestExample => ({
    type: REQUEST_EXAMPLE,
    clean,
})

export const requestSource = (id: string): ConfigurationId => ({
    type: REQUEST_SOURCE,
    id,
})

export const receiveSource = (source: string): PackageSource => ({
    type: RECEIVE_SOURCE,
    source,
})

export const saveSource = (source: string): PackageSource => ({
    type: SAVE_SOURCE,
    source,
})

export const closeEditor = (): Action => ({ type: CLOSE_EDITOR })

export const requestPackageDiff = (id: string): ConfigurationId => ({
    type: REQUEST_PACKAGE_DIFF,
    id,
})

export const receivePackageDiff = (
    packageDiff: IPackageDiff,
): ReceivePackageDiff => ({ type: RECEIVE_PACKAGE_DIFF, packageDiff })

export const makeSnapshot = (id: string): ConfigurationId => ({
    type: MAKE_SNAPSHOT,
    id,
})

export const requestPackageAddinDiffs = (id: string): ConfigurationId => ({
    type: REQUEST_PACKAGE_ADDIN_DIFFS,
    id,
})

export const receivePackageAddinDiffs = (
    id: string,
    addinDiffs: IAddin[],
): ReceivePackageAddinDiffs => ({
    type: RECEIVE_PACKAGE_ADDIN_DIFFS,
    id,
    addinDiffs,
})

export const mapDispatchToProps = {
    requestConfigurations,
    requestInstalledConfigurations,
    receiveConfigurations,
    exportConfiguration,
    removeConfiguration,
    requestExample,
    requestSource,
    saveSource,
    closeEditor,
    makeSnapshot,
    requestPackageAddinDiffs,
    receivePackageAddinDiffs,
}

export type DispatchProps = typeof mapDispatchToProps
